var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99913 8C6.73313 8 6.47913 7.895 6.29213 7.707L0.293128 1.707C-0.097872 1.316 -0.097872 0.683 0.293128 0.293C0.684128 -0.0979996 1.31613 -0.0979996 1.70713 0.293L6.99913 5.586L12.2931 0.293C12.6841 -0.0979994 13.3161 -0.0979994 13.7071 0.293C14.0981 0.684 14.0981 1.316 13.7071 1.707L7.70613 7.707C7.51913 7.895 7.26513 8 6.99913 8Z",
    fill: "#E81111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrow);
export default __webpack_public_path__ + "static/media/RedArrow.af14e1843b1ea00b4e278d6978d3fa80.svg";
export { ForwardRef as ReactComponent };